import { render, staticRenderFns } from "./popup-folder-edit.vue?vue&type=template&id=82bb8690&scoped=true"
import script from "./popup-folder-edit.vue?vue&type=script&lang=js"
export * from "./popup-folder-edit.vue?vue&type=script&lang=js"
import style0 from "./popup-folder-edit.vue?vue&type=style&index=0&id=82bb8690&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82bb8690",
  null
  
)

export default component.exports